
export const EmailColumnFormatter = ( cellContent, row, rowIndex ) => (
    ( cellContent === '' || cellContent === null ) ? 'N/A' : cellContent
);